// extracted by mini-css-extract-plugin
export default {"imagem":"NaoEncontrada_imagem__bc8Wm"};